import React from 'react';
import styled from 'styled-components';
import treeLocations from '../../Assets/TreePlanting/TreeLocations.png';
import kindred from '../../Assets/TreePlanting/Kindred.png';
import dotsEco from '../../Assets/TreePlanting/DotsEco.png';
import earthmark from '../../Assets/TreePlanting/Earthmark.png';
import cnb from '../../Assets/TreePlanting/Cnb.png';
import verifiedCarbon from '../../Assets/TreePlanting/VerifiedCarbon.png';
import urs from '../../Assets/TreePlanting/Urs.png';
import { mobileMediaQuery, tabletMediaQuery, themeColor } from '../../Theming';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  width: 100%;
  height: auto;
  display: block;
  text-align: center;
  justify-content: center;
  align-items: center;
  background-color: ${themeColor('white')};
  margin-bottom: 30px;

  ${mobileMediaQuery} {
    width: 100%;
    height: 600px;
    margin-bottom: 0px;
  }
`;

const PartnersContainer = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  text-align: center;
  justify-content: space-between;
  margin-top: 30px;
  padding-left: 230px;
  padding-right: 230px;

  ${tabletMediaQuery} {
    height: 150px;
    display: flex;
    flex-wrap: wrap;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: start;
  }
`;

const HeaderText = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 45px;
  line-height: 54px;
  text-align: center;
  margin-top: 120px;

  ${mobileMediaQuery} {
    font-weight: 700;
    font-size: 26px;
    line-height: 31px;
    margin-top: 80px;
    padding-left: 40px;
    padding-right: 40px;
  }
`;

const TreeLocationsMap = styled.img`
  width: 60%;
  margin-top: 0px;

  ${mobileMediaQuery} {
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const StyledLogo = styled.img`
  margin-top: 20px;
  max-width: 129px;
  max-height: 47px;

  ${mobileMediaQuery} {
    max-width: 100px;
    max-height: 36px;
  }
`;

const StyledURSLogo = styled(StyledLogo)`
  margin-top: 0px;
  margin-right: 30px;
  max-width: 124px;
  max-height: 101px;

  ${mobileMediaQuery} {
    max-width: 95px;
    max-height: 78px;
    margin-right: 10px;
    margin-left: 0px;
  }
`;

const StyledVerifiedCarbonLogo = styled(StyledLogo)`
  margin-top: 0px;
  margin-right: 40px;
  max-width: 147px;
  max-height: 83px;

  ${mobileMediaQuery} {
    max-width: 114px;
    max-height: 64px;
    margin-right: 10px;
  }
`;

const StyledCnbLogo = styled(StyledLogo)`
  margin-top: 20px;
  margin-right: 40px;
  max-width: 53px;
  max-height: 66px;

  ${mobileMediaQuery} {
    max-width: 32px;
    max-height: 40px;
    margin-left: 15px;
    margin-right: 30px;
  }
`;

const StyledDotsEcoLogo = styled(StyledLogo)`
  margin-top: 20px;
  margin-right: 40px;
  max-width: 93px;
  max-height: 63px;

  ${mobileMediaQuery} {
    max-width: 56px;
    max-height: 38px;
    margin-right: 20px;
  }
`;

const StyledEarthmarkLogo = styled(StyledLogo)`
  margin-top: 35px;
  max-width: 167px;
  max-height: 24px;

  ${mobileMediaQuery} {
    max-width: 98px;
    max-height: 28px;
  }
`;
const WhereAreTreesPlanted: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <HeaderText>{t('treePlanting.whereAreTreesBeingPlanted')}</HeaderText>
      <TreeLocationsMap src={treeLocations} />
      <PartnersContainer>
        <StyledLogo src={kindred} />
        <StyledURSLogo src={urs} />
        <StyledVerifiedCarbonLogo src={verifiedCarbon} />
        <StyledCnbLogo src={cnb} />
        <StyledDotsEcoLogo src={dotsEco} />
        <StyledEarthmarkLogo src={earthmark} />
      </PartnersContainer>
    </Container>
  );
};

export default WhereAreTreesPlanted;
